import "@/App.css";
import Deck from "./deck/Deck";

function App() {
  return <Deck />;
}

export default App;
